import request from '@/shared/api/request';

/**
 *
 * Returns token.
 *
 * @returns {Promise}
 */
export const login = (data: { email: string; password: string }): Promise<{ token: string }> =>
  request({
    url: '/account/login/',
    method: 'POST',
    withCredentials: true,
    data,
  });
